import {
  SiInstagram,
  SiSpotify,
  SiYoutube,
  SiApplemusic,
} from 'react-icons/si'
import { ExternalLink } from 'lucide-react'

interface SocialIconProps {
  platform: string
  className?: string
}

export function SocialIcon({ platform, className = 'h-4 w-4' }: SocialIconProps) {
  switch (platform.toLowerCase()) {
    case 'instagram': return <SiInstagram className={className} />
    case 'spotify': return <SiSpotify className={className} />
    case 'youtube': return <SiYoutube className={className} />
    case 'apple_music': return <SiApplemusic className={className} />
    default: return <ExternalLink className={className} />
  }
}
